<template>
    <div>
        <card>
            <Form :model="searchForm" inline>
                <FormItem>
                    <Input type="text" v-model="searchForm.keyword" placeholder="姓名/电话"/>
                </FormItem>
                <Form-item prop="zoneId" label="校区" :label-width="60">
                    <Select v-model="searchForm.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem>
                    <Button type="primary" size="small" @click="getStudentList" style="margin-right: 5px;">查询</Button>
                    <Button type="primary" size="small" @click="addStudent" style="margin-right: 5px;">新增</Button>
                    <Button type="primary" size="small" @click="exportStudent" v-if="$store.state.user.isadmin == 1">导出</Button>
                    <!--<Upload :action="uploadUrl"-->
                            <!--style="display: inline-block;margin-left: 10px;"-->
                            <!--:with-credentials="true"-->
                            <!--:show-upload-list="false"-->
                            <!--:on-success="handleSuccess"-->
                            <!--v-if="$store.state.user.isadmin == 1"-->
                            <!--:before-upload="handleBeforeUpload"-->
                            <!--:on-error="handleUploadError"-->
                            <!--&gt;-->
                        <!--<Button icon="md-cloud-upload" size="small" v-if="$store.state.user.isadmin == 1">导入学员</Button>-->
                    <!--</Upload>-->
                    <!--&nbsp;&nbsp;&nbsp;<a href="/static/import-tpl.xlsx">下载模板和导入说明</a>-->
                </FormItem>
            </Form>
            <Table :columns="studentTable.columns" :data="studentTable.data">
                <template slot-scope="{ row, index }" slot="studentInfo">
                    <div style="padding:8px;text-align: left;padding-left:0">
                        <div style="font-size: 14px;font-weight: bold">{{row.name}}</div>
                        <div style="font-size: 12px;color:#a6a4a4">{{row.stu_no}}</div>
                        <div style="font-size: 12px;color:#a6a4a4" v-if="row.sex == 1">男</div>
                        <div style="font-size: 12px;color:#a6a4a4" v-if="row.sex == 2">女</div>
                    </div>
                </template>
                <template slot-scope="{ row, index }" slot="clazz">
                    <template v-if="row.classId" >
                        <template v-for="(item,i) in row.classId.split(',')">
                            <router-link style="display:block;" :to="{name:'clazz_detail',query:{id:item}}">
                                {{row.clazz.split(',')[i]}}
                            </router-link>
                        </template>
                    </template>
                </template>
            </Table>
            <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total
                  @on-change="changePage" :page-size="20"></Page>
        </card>
        <Modal v-model="finishModal" width="360">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>确认进行结课操作？</span>
            </p>
            <div style="text-align:center">
                <p>将清除此学员所有未上课程，剩余的课时也将清0？</p>
                <p>是否确认操作（此操作不可恢复）?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long @click="finish">确认结课</Button>
            </div>
        </Modal>
        <Modal v-model="zoneModal" title="转校区">
            <Form :label-width="60"  ref="zoneForm">
                <FormItem  label="原校区">
                    <Select v-model="oldZone"  style="width:300px;" :disabled="true">
                        <Option v-for="(item,index) in zoneList" :key="index" :value="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="新校区">
                    <Select v-model="newZone"  style="width:300px;">
                        <Option v-for="(item,index) in zoneList" :key="index" :value="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" size="small" @click="changeZone()">确认</Button>
                <Button type="default" size="small" @click="zoneModal=!zoneModal">取消</Button>
            </div>
        </Modal>
        <Modal v-model="showErrorWin" title="导入数据异常">
            <CellGroup>
                <Cell v-for="(item) in errorData" :title="item" />
            </CellGroup>
        </Modal>
        <Modal v-model="showImportWin" title="确认导入数据" width="2000">
            <Table :columns="importColumns" :data="importData"></Table>
            <div slot="footer">
                <div style="text-align: left">
                    <Button type="primary" size="small" @click="doImport()" :loading="importLoading">确认导入</Button>
                    <Button type="default" size="small" @click="showImportWin=!showImportWin">取消</Button>
                </div>
            </div>
        </Modal>

    </div>
</template>

<script>
  import config from '@/config'
  const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
  export default {
    name: 'student_index',
    data() {
      return {
        importLoading:false,
        importColumns:[
          {
            title:'校区',
            key:'zoneName'
          },
          {
            title:'姓名',
            key:'name'
          },
          {
            title:'生日',
            key:'birthday'
          },
          {
            title:'家长1',
            key:'parentName1'
          },
          {
            title:'家长1电话',
            key:'parentMobile1'
          },
          {
            title:'课时',
            key:'course1Num'
          },
          {
            title:'课程',
            key:'course1Name'
          },
          {
            title:'教师',
            key:'course1TeacherName'
          },
          {
            title:'日期',
            render: (h, params) => {
              return h('div', {}, params.row.course1StartDate + ' 至 ' +params.row.course1EndDate);
            }
          },
          {
            title:'时间',
            render: (h, params) => {
              if (params.row.course1StartTime){
                return h('div', {}, params.row.course1StartTime + ' 至 ' +params.row.course1EndTime);
              }else{
                return "";
              }

            }
          },
          {
            title:'星期几',
            key:'course1WeekDay'
          },
          {
            title:'课时',
            key:'course2Num'
          },
          {
            title:'课程',
            key:'course2Name'
          },
          {
            title:'教师',
            key:'course2TeacherName'
          },
          {
            title:'日期',
            render: (h, params) => {
              if (params.row.course2StartDate){
                return h('div', {}, params.row.course2StartDate + ' 至 ' +params.row.course2EndDate);
              }else{
                return "";
              }

            }
          },
          {
            title:'时间',
            render: (h, params) => {
              if (params.row.course2StartTime){
                return h('div', {}, params.row.course2StartTime + ' 至 ' +params.row.course2EndTime);
              }else{
                return "";
              }

            }
          },
          {
            title:'星期几',
            key:'course2WeekDay'
          }
        ],
        showImportWin:false,
        importData:[],
        showErrorWin:false,
        errorData:[],
        uploadUrl:'',
        choosed: null,
        totalPage: 0,
        pageTotalNum: 0,
        pageCurrent: 1,
        searchForm: {
          keyword: ''
        },
        finishModal: false,
        zoneModal:false,
        newZone:null,
        oldZone:null,
        studentTable: {
          columns: [
            {
              title:'学员',
              slot:'studentInfo',
              width:240
            },
            // {
            //   title:'学号',
            //   key:'stu_no',
            //   align:'center'
            // },
            // {
            //   title: '姓名',
            //   key: 'name',
            //   align: 'center'
            // },
            // {
            //   title: '性别',
            //   key: 'sex',
            //   align: 'center',
            //   render: (h, params) => {
            //     let self = this;
            //     let opArray = [];
            //     let sex = '';
            //     if (params.row.sex == 1){
            //       sex = '男'
            //     }else if (params.row.sex == 2){
            //       sex = '女';
            //     }
            //     opArray.push(h('span', {}, sex));
            //     return h('div', {}, opArray);
            //   }
            // },
            {
              title: '班级',
              slot: 'clazz',
              align: 'center'
            },
            {
              title: '课程',
              key: 'course',
              align: 'center'
            },
            {
              title: '状态',
              key: 'state',
              width:100,
              render: (h, params) => {
                if (params.row.state == 1){
                  return h('Tag',
                    {
                      props: {
                        color: 'primary'
                      },
                    },'正常');
                }else if (params.row.state == 2){
                  return h('Tag',
                    {
                      props: {
                        color: 'error'
                      },
                    },'已停课');
                }else if (params.row.state == 3){
                  return h('Tag',
                    {
                      props: {
                        color: 'success'
                      },
                    },'已结课');
                }

              }
            },
            {
              title: '备注',
              key: 'remark',
              algin: 'center'
            },
            {
              title: '操作',
              width:260,
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      console.log(params.row.id)
                      this.$router.push({
                        name: 'student_detail',
                        query: {
                          id: params.row.id,
                        }
                      })
                    }
                  }
                }, '详情'));
                // if (params.row.state ==1){
                //   opArray.push(h('Button', {
                //     props: {
                //       type: 'info',
                //       size: 'small'
                //     },
                //     style: {
                //       marginRight: '5px'
                //     },
                //     on: {
                //       click: () => {
                //         let self = this;
                //         self.choosed = params.row.id;
                //         self.finishModal = true;
                //       }
                //     }
                //   }, '停课'));
                // }else if (params.row.state ==2){
                //   opArray.push(h('Button', {
                //     props: {
                //       type: 'info',
                //       size: 'small'
                //     },
                //     style: {
                //       marginRight: '5px'
                //     },
                //     on: {
                //       click: () => {
                //         let self = this;
                //         self.choosed = params.row.id;
                //         self.finishModal = true;
                //       }
                //     }
                //   }, '复课'));
                // }
                if (params.row.state != 3){
                  opArray.push(h('Button', {
                    props: {
                      type: 'info',
                      size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        let self = this;
                        self.choosed = params.row.id;
                        self.finishModal = true;
                      }
                    }
                  }, '结课'));
                }
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let self = this;
                      self.choosed = params.row.id;
                      self.oldZone = params.row.zone_id;
                      self.newZone = null;
                      self.zoneModal = true;
                    }
                  }
                }, '转校'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let self = this;
                      self.$Modal.confirm({
                        title: '确认删除?',
                        content: '确认删除该学生?',
                        onOk() {
                          this.$api.student.delStudent({id: params.row.id}).then(res => {
                            if (res.state == "ok") {
                              self.$Message.success("删除成功")
                              self.getStudentList()
                            } else {
                              self.$Message.error(res.msg)
                            }
                          })
                        },
                        onClose() {
                        }
                      })
                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }

          ],
          data: []
        }
      }
    },
    mounted() {
      this.getStudentList();
      // const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
      this.uploadUrl = baseUrl + 'edu/web/student/uploadImportFile';
    },
    methods: {
      doImport(){
        let self = this;
        if (self.importData && self.importData.length > 0){
          self.importLoading = true;
          self.$api.student.doImport({importData:JSON.stringify(self.importData)}).then(resp=>{
            self.importLoading = false;
            if (resp.state == 'ok'){
              self.$Message.info({
                content:'导入成功',
                onClose(){
                  self.showImportWin = false;
                  self.importData = [];
                  self.getStudentList();
                }
              });
            }else{
              self.$Message.error(resp.msg);
            }
          });
        }else{
          self.$Message.error("没有数据");
        }
      },
      handleSuccess(resp, file, fileList){
        this.$Message.destroy()
        if (resp.state == 'ok'){
          this.showImportWin = true;
          this.importData = resp.data;
        }else{
          if (resp.data){
            this.showErrorWin = true;
            this.errorData = resp.data;
          }else{
            this.$Message.error(resp.msg);
          }
        }
      },
      handleBeforeUpload(file){
        this.$Message.loading({
          content: '上传中，请稍后',
          duration: 0
        });
      },
      handleUploadError(error, file, fileList){
        this.$Message.destroy();
        this.$Message.error("上传失败："+JSON.stringify(error));
      },
      changeZone() {
        let self = this;
        if (!self.newZone){
          self.$Message.error("请选择新校区");
          return;
        }
        if (self.newZone == self.oldZone){
          self.$Message.error("新校区和旧校区不能相同");
          return;
        }
        self.$api.student.changeZone({id: self.choosed,newZone:self.newZone}).then(resp => {
          if (resp.state == 'ok') {
            self.$Message.info({
              content:'转校成功',
              onClose(){
                self.getStudentList();
              }
            });

            self.zoneModal = false;
          } else {
            this.saving = false;
            self.$Message.error(resp.msg);
          }
        });
      },
      finish(){
        let self = this;
        self.$api.student.finish({id: self.choosed}).then(resp => {
          if (resp.state == 'ok') {
            self.$Message.info('结课成功');
            self.getStudentList();
            self.finishModal = false;
          } else {
            this.saving = false;
            self.$Message.error(resp.msg);
          }
        });
      },
      getStudentList() {
        this.pageTotalNum = 0;
        this.studentTable.data = []
        let param = {
          page: this.pageCurrent,
          keyword: this.searchForm.keyword,
          zoneId:this.searchForm.zoneId
        }
        this.$api.student.list(param).then(res => {
          if (res.state == "ok") {
            this.pageTotalNum = res.data.totalRow;
            this.totalPage = res.data.totalPage;
            this.pageCurrent = res.data.pageNumber;
            this.studentTable.data = res.data.list;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      changePage(page) {
        this.pageCurrent = page;
        this.getStudentList();
      },
      addStudent() {
        this.$router.push({
          name: 'student_detail'
        })
      },
      exportStudent(){
        window.open(baseUrl+'edu/web/student/export')
      }
    },
    computed: {
      showPager: function () {
        return this.totalPage > 1
      },
      zoneList() {
        return this.$store.state.app.zoneList
      },
    },
  }
</script>
